@if (isAdmin && canViewAs) {
  <div class="admin-view-as-banner" [class.active]="isViewingAsOther()">
    @if (!isViewingAsOther()) {
      <!-- Sélecteur d'utilisateur -->
      <div class="selector-container">
        <mat-icon class="selector-icon" aria-hidden="true">visibility</mat-icon>
        <mat-form-field appearance="outline" class="user-search">
          <mat-label>{{ 'view_as.label' | translate }}</mat-label>
          <input
            type="text"
            matInput
            [formControl]="search"
            [matAutocomplete]="auto"
            [placeholder]="'view_as.placeholder' | translate"
          />
          <mat-autocomplete
            #auto="matAutocomplete"
            (optionSelected)="selectUser($event.option.value)"
            [displayWith]="displayUser"
          >
            @for (user of usersToSelect(); track user.id) {
              <mat-option [value]="user">
                {{ user.igg | uppercase }} - {{ user.firstname }} {{ user.lastname | uppercase }}
              </mat-option>
            }
          </mat-autocomplete>
          <mat-icon matSuffix aria-hidden="true">search</mat-icon>
        </mat-form-field>
      </div>
    } @else {
      <!-- Mode visualisation actif -->
      <div class="viewing-indicator">
        <mat-icon class="indicator-icon" aria-hidden="true">person</mat-icon>
        <span class="viewing-text">
          {{ 'view_as.viewing' | translate }} <strong>{{ getViewedUserDisplayName() }}</strong>
        </span>
        <span class="read-only-badge">{{ 'view_as.read_only' | translate }}</span>
        <button mat-stroked-button color="warn" (click)="clearViewedUser()" class="exit-button">
          <mat-icon aria-hidden="true">close</mat-icon>
          {{ 'view_as.exit' | translate }}
        </button>
      </div>
    }
  </div>
}
